import React from 'react';
import Alert from 'react-s-alert';

export default class AlertComponent extends React.Component {

    render() {
        return (
            <div>
                <Alert
                    stack={{ limit: 5 }}
                    position={'top-right'}
                    effect={'genie'}
                    timeout={10000}
                    offset={60}
                />
            </div>
        );
    }
}

AlertComponent.propTypes = {};

AlertComponent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/alert/AlertComponent.js